import type React from "react";
import { ReactComponent as Svg } from "./assets/icon-comments.svg";
import * as styles from "./Icon.module.scss";

type CommentsProps = React.SVGProps<SVGSVGElement>;

export const Comments = ({ className, ...props }: CommentsProps) => (
  <Svg className={className ?? styles.base} {...props} />
);
